export { default } from 'src/containers/Home'
import { GetStaticProps } from 'next'
import { ENVIRONMENT, SHOW_INSIGHTS_HOME, SHOW_PRACTICE_AREAS, THEME } from 'src/config/config'
import { AUDIENCE_CONFIG } from 'src/constants/constants'
import { HomePageProps } from 'src/containers/Home/Home'
import { apolloSdk } from 'src/graphql/apolloSdk'
import {
  IIltaSponsorshipItemFragment,
  IPopularTopic,
  ITestimonialItemFragment,
  ITopicItemFragment,
} from 'src/graphql/generated/hooks'

export const getStaticProps: GetStaticProps<HomePageProps> = async () => {
  let props: HomePageProps
  try {
    if (THEME === 'legaltech') {
      const [
        { topics },
        { testimonialsPlural },
        // { premiumAudiences },
        { popularTopics },
        //{ topics: premiumTopics },
        //{ subTopics: premiumSubTopics },
        { practiceAreas },
      ] = await Promise.all([
        apolloSdk.getTopicsForHeader(), //apolloSdk.getTopicsWithoutSubs(),
        apolloSdk.globalTestimonials(), //1
        /*  apolloSdk.premiumAudiences({
          filters: { shouldShowOnHomepage: { eq: true } },
          sort: ['name:desc'],
        }), */
        apolloSdk.popularTopics({ vendorLimit: 6 }),
        //apolloSdk.premiumTopics(),
        //apolloSdk.premiumSubTopics(),
        SHOW_PRACTICE_AREAS ? apolloSdk.getPracticeAreas() : Promise.resolve({ practiceAreas: [] }),
      ])
      const getEnviromentName = () => {
        const env = ENVIRONMENT ? ENVIRONMENT.toLowerCase()?.trim() : 'develop'
        let AudienceDocumentId = ''
        if (env == 'develop') {
          AudienceDocumentId = AUDIENCE_CONFIG.develop
        } else if (env == 'production') {
          AudienceDocumentId = AUDIENCE_CONFIG.production
        } else if (env == 'uat') {
          AudienceDocumentId = AUDIENCE_CONFIG.uat
        } else {
          AudienceDocumentId = AUDIENCE_CONFIG.localhost
        }
        return AudienceDocumentId
      }
      const qury = {
        query: {
          isTrending: true,
          includeInKnowHow: true,
          limit: 6,
          sort: 'Chronologically',
          audienceIds: getEnviromentName(),
        },
      }

      let trendingContent: any = []
      if (SHOW_INSIGHTS_HOME) {
        const { contentResults } = await apolloSdk.searchContents(qury)
        trendingContent = contentResults?.data?.contents || []
      }

      // const premiumCategories: any[] = (premiumTopics?.data || []).concat((premiumSubTopics?.data || []) as any)
      props = {
        theme: 'legaltech',
        //audiences: premiumAudiences?.data || [],
        topics: (topics || []) as ITopicItemFragment[],
        testimonials: (testimonialsPlural || []).filter((item): item is ITestimonialItemFragment => item !== null),
        popularTopics: popularTopics as IPopularTopic[],
        trendingContents: trendingContent,
        //premiumCategories,
        practiceAreas: SHOW_PRACTICE_AREAS ? practiceAreas?.filter((item) => item?.name !== 'Neutral') || [] : [],
      }
    } else {
      const [{ topics }, { iltaSponsorships }] = await Promise.all([
        apolloSdk.getTopicsWithoutSubs(),
        apolloSdk.getIltaSponsorships(),
      ])
      props = {
        theme: 'ilta',
        topics: (topics || []) as ITopicItemFragment[],
        iltaSponsorships: (iltaSponsorships ?? []).filter((s): s is IIltaSponsorshipItemFragment => s !== null),
        trendingContents: [],
      }
    }
    return {
      props,
      revalidate: 60,
    }
  } catch (error) {
    const errorDetails =
      error instanceof Error
        ? {
            name: error.name,
            message: error.message,
            stack: error.stack,
          }
        : { value: error }

    // Logs server-side failure cause for easier debugging in local/dev logs.

    // eslint-disable-next-line no-console
    console.error('[index.getStaticProps] Failed to resolve home page data', {
      theme: THEME,
      showInsightsHome: SHOW_INSIGHTS_HOME,
      graphQlHost: process.env.NEXT_PUBLIC_GRAPHGL_API_HOST,
      error: errorDetails,
    })

    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 5, // Reattempt fetching during the next static regeneration
    }
  }
}
